import React from 'react';
import { Modal, ModalTitle } from '..';
import Icon, { IconType } from '../../../icons/Icon';
import { IconButton } from '../../Button';

interface AlertModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  title: string;
  children: React.ReactNode;
}

export default function AlertModal({ open, setOpen, title, children }: AlertModalProps) {
  return (
    <Modal open={open} setOpen={setOpen}>
      <div className='p-6'>
        <div className='mb-4 flex h-[28px] items-center justify-between gap-4'>
          <div className='flex items-center gap-2'>
            <Icon type={IconType.alertTriangle} fill={'fill-error-500'} stroke={'stroke-white'} />
            <ModalTitle text={title} />
          </div>
          <IconButton type={IconType.xClose} stroke={'stroke-gray-400'} onClick={() => setOpen(false)} />
        </div>
        {children}
      </div>
    </Modal>
  );
}
